import React, { Fragment } from 'react';
import { object, string, func, shape } from 'prop-types';
import { Image } from 'react-bootstrap';

import ICON_SORT from 'Icon/icon-sort.png';
import ICON_SORT_ASC from 'Icon/icon-sort-desc.png';
import ICON_SORT_DESC from 'Icon/icon-sort-asc.png';
import { noop } from '@ajaibid/utils';

const TableSortButton = ({
  order,
  orderType,
  headerContents,
  setOrder,
  setOrderType,
  handleClickColumnSort,
}) => (
  <Fragment>
    {order === headerContents.order && (
      <Image
        src={orderType === 'asc' ? ICON_SORT_ASC : ICON_SORT_DESC}
        className="pointer"
        style={{ width: 16, height: 12 }}
        onClick={() => {
          setOrder(headerContents.order);
          setOrderType(orderType === 'asc' ? 'desc' : 'asc');
          handleClickColumnSort(headerContents.order);
        }}
      />
    )}
    {order !== headerContents.order && (
      <Image
        src={ICON_SORT}
        className="pointer"
        style={{ width: 16, height: 12 }}
        onClick={() => {
          setOrder(headerContents.order);
          setOrderType('asc');
          handleClickColumnSort(headerContents.order);
        }}
      />
    )}
  </Fragment>
);

TableSortButton.propTypes = {
  order: string,
  orderType: string,
  headerContents: shape({
    order: string,
    text: string,
    style: object,
    className: string,
  }),
  setOrder: func,
  setOrderType: func,
  handleClickColumnSort: func,
};

TableSortButton.defaultProps = {
  order: '',
  orderType: '',
  headerContents: {},
  setOrder: noop,
  setOrderType: noop,
  handleClickColumnSort: noop
};

export default TableSortButton;
